
import { writable } from 'svelte/store';

export const paramsUser = writable({
  total: 0,
  page: 1,
  xpage: 10,
  search: '',
  searching: '',
  clientcode:''
});

export const paramsGames = writable({
  total: 0,
  page: 1,
  xpage: 10,
  search: '',
  searching: '',
  brand:'',
  provider:'',
  category:''

});

export const paramsClients = writable({
  total: 0,
  page: 1,
  xpage: 10,
  search: '',
  searching: ''
});
